import { render } from "./StartWindow.vue?vue&type=template&id=718e14d3&scoped=true"
import script from "./StartWindow.vue?vue&type=script&lang=js"
export * from "./StartWindow.vue?vue&type=script&lang=js"

import "./StartWindow.vue?vue&type=style&index=0&id=718e14d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718e14d3"]])

export default __exports__